import { axios } from "@/lib/axios";
import { AxiosResponse } from "axios";
import { TExportActif, TExportResilie } from "../types/profile.types";

// Les exports PDF de gros volumes (rendu WeasyPrint) peuvent prendre plusieurs
// minutes, bien au-delà du timeout par défaut du client.
const EXPORT_TIMEOUT_MS = 10 * 60 * 1000;

export const ExportReportResilie = (
  data: TExportResilie
): Promise<AxiosResponse<any, any>> => {
  return axios.post("/download-report", data, {
    responseType: "blob",
    timeout: EXPORT_TIMEOUT_MS,
  });
};

export const ExportReportActif = (
  data: TExportActif
): Promise<AxiosResponse<any, any>> => {
  return axios.post("/download-report", data, {
    responseType: "blob",
    timeout: EXPORT_TIMEOUT_MS,
  });
};
